export default {
  common: {
    save: "സേവ് ചെയ്യുക",
    cancel: "റദ്ദാക്കുക",
    back: "തിരികെ",
    submit: "സമർപ്പിക്കുക",
    loading: "ലോഡ് ചെയ്യുന്നു…",
    yes: "അതെ",
    no: "ഇല്ല",
    confirm: "സ്ഥിരീകരിക്കുക",
    close: "അടയ്ക്കുക",
    search: "തിരയുക",
    all: "എല്ലാം",
    done: "പൂർത്തിയായി",
    logout: "ലോഗ് ഔട്ട്",
    language: "ഭാഷ",
    selectLanguage: "നിങ്ങളുടെ ഭാഷ തിരഞ്ഞെടുക്കുക",
    saving: "സേവ് ചെയ്യുന്നു…",
    saved: "സേവ് ചെയ്തു",
    viewAll: "എല്ലാം കാണുക",
    filters: "ഫിൽറ്ററുകൾ",
  },
  nav: {
    home: "ഹോം",
    installs: "ഇൻസ്റ്റാളേഷനുകൾ",
    requests: "അഭ്യർത്ഥനകൾ",
    orders: "ഓർഡറുകൾ",
    profile: "പ്രൊഫൈൽ",
    leads: "ലീഡുകൾ",
    service: "സേവനം",
    payouts: "പേയ്‌മെന്റുകൾ",
    toolkit: "ടൂൾകിറ്റ്",
  },
  profile: {
    yourAccount: "നിങ്ങളുടെ അക്കൗണ്ട്",
    title: "പ്രൊഫൈൽ.",
    city: "നഗരം",
    state: "സംസ്ഥാനം",
    pinCode: "പിൻ കോഡ്",
    pinCodeHelp: "ഈ പിൻ കോഡ് ഉൾപ്പെടുന്ന അനുവദനീയ പ്രദേശമാണ് നിങ്ങളുടെ മേഖല.",
    upiId: "UPI ഐഡി (പേയ്‌മെന്റുകൾക്കായി)",
    saveProfile: "പ്രൊഫൈൽ സേവ് ചെയ്യുക",
    preferredLanguage: "ഇഷ്ടപ്പെട്ട ഭാഷ",
    logoutConfirm: "നിങ്ങൾക്ക് ശരിക്കും ലോഗ് ഔട്ട് ചെയ്യണോ?",
    linkedAddresses: "ലിങ്ക് ചെയ്ത വിലാസങ്ങൾ",
    noAddresses: "ഇതുവരെ വിലാസങ്ങളൊന്നും സേവ് ചെയ്തിട്ടില്ല.",
    referFriend: "സുഹൃത്തിനെ റഫർ ചെയ്യുക",
    referFriendSub: "നിങ്ങളുടെ കോഡ് പങ്കിടുക — അവർ സോളാർ സ്ഥാപിച്ചാൽ നിങ്ങൾക്ക് റിവാർഡ് ലഭിക്കും.",
    myReferrals: "എന്റെ റഫറലുകൾ",
    shareFriend: "സുഹൃത്തുമായി പങ്കിടുക",
    secureNote: "നിങ്ങളുടെ ഡാറ്റ സുരക്ഷിതമായ ഫോൺ OTP വഴി പരിശോധിച്ചുറപ്പിച്ചതാണ് — പാസ്‌വേഡ് ഓർത്തിരിക്കുകയോ നഷ്ടപ്പെടുകയോ വേണ്ട.",
    toolkit: "ടൂൾകിറ്റ്",
    incentiveSchemes: "ഇൻസെന്റീവ് പദ്ധതികൾ",
  },
  tickets: {
    myRequests: "എന്റെ അഭ്യർത്ഥനകൾ",
    raiseComplaint: "പരാതി രേഖപ്പെടുത്തുക",
    cancelRequest: "അഭ്യർത്ഥന റദ്ദാക്കുക",
    cancelConfirmTitle: "ഈ അഭ്യർത്ഥന റദ്ദാക്കണോ?",
    cancelConfirmBody: "ഈ സേവന അഭ്യർത്ഥനയിലെ ജോലി ഞങ്ങൾ നിർത്തും. നിങ്ങൾക്ക് പിന്നീട് വീണ്ടും പുതിയ അഭ്യർത്ഥന നൽകാം.",
    cancelledToast: "അഭ്യർത്ഥന റദ്ദാക്കി",
    keepRequest: "വേണ്ട, നിലനിർത്തുക",
    noRequests: "ഇതുവരെ സേവന അഭ്യർത്ഥനകളൊന്നുമില്ല.",
    statusOpen: "തുറന്നിരിക്കുന്നു",
    statusInProgress: "പുരോഗതിയിൽ",
    statusOnHold: "നിർത്തിവച്ചു",
    statusActionNeeded: "നടപടി ആവശ്യം",
    statusCompleted: "പൂർത്തിയായി",
    statusClosed: "അടച്ചു",
    statusCancelled: "റദ്ദാക്കി",
    statusDropped: "ഉപേക്ഷിച്ചു",
    filterAll: "എല്ലാം",
    filterActive: "സജീവം",
    filterResolved: "പരിഹരിച്ചു",
    nonServiceable: "സേവനം ലഭ്യമല്ലാത്ത പ്രദേശം",
    raisedOn: "രേഖപ്പെടുത്തിയത്",
    ticketNumber: "ടിക്കറ്റ്",
    wipInstall: "ഇൻസ്റ്റാളേഷൻ നടക്കുന്നു",
    raisedByYou: "നിങ്ങൾ രേഖപ്പെടുത്തി",
    raisedByTeam: "ഞങ്ങളുടെ ടീം രേഖപ്പെടുത്തി",
    timeline: "ടൈംലൈൻ",
    pending: "തീർപ്പാക്കാത്തത്",
    resolutionSummary: "പരിഹാര സംഗ്രഹം",
    youRatedPrefix: "നിങ്ങൾ ഇത് റേറ്റ് ചെയ്തു",
    howWasResolution: "പരിഹാരം എങ്ങനെയായിരുന്നു?",
    submitFeedback: "ഫീഡ്‌ബാക്ക് സമർപ്പിക്കുക",
  },
  home: {
    greeting: "നമസ്കാരം",
    newInstallation: "പുതിയ ഇൻസ്റ്റാളേഷൻ",
    raiseComplaint: "പരാതി രേഖപ്പെടുത്തുക",
    welcomeBack: "വീണ്ടും സ്വാഗതം",
    customerSubtitle: "പൂർവോദയത്തോടൊപ്പം നിങ്ങളുടെ സോളാർ യാത്ര, എല്ലാം ഒരിടത്ത്.",
  },
  sc: {
    requestsTitle: "സേവന അഭ്യർത്ഥനകൾ",
    requestsForCustomers: "നിങ്ങളുടെ ഉപഭോക്താക്കൾക്കായി",
    kpiOpen: "തുറന്നത്",
    kpiResolved: "പരിഹരിച്ചു",
    kpiInProblem: "പ്രശ്നത്തിൽ",
    raiseRequest: "സേവന അഭ്യർത്ഥന രേഖപ്പെടുത്തുക",
    slaBreached: "SLA ലംഘനം",
    viewPhotos: "ഫോട്ടോകൾ കാണുക",
    hidePhotos: "ഫോട്ടോകൾ മറയ്ക്കുക",
    noRequestsWindow: "ഈ കാലയളവിൽ സേവന അഭ്യർത്ഥനകളൊന്നുമില്ല.",
  },
};
